<!-- 接入指南 -->
<template>
    <div class="content">
        <el-backtop ></el-backtop>
        <ul>
            <li>
                <h2 class="title">接入指南</h2>
                <h3>获取接入权限</h3>
                <div>
                <div>1.如您第一次使用智慧停车开放平台，请先联系艾科业务员（对应项目业务员）或智慧停车客服电话:400-682-3828，我们会安排专业人员跟您对接确认需求。</div>
                <div>2.确认好需求后， 停车场管理方联系相关业务员协助提交申请
                </div>
                </div>
            </li>
        </ul>

        <ul>
            <li>
                <h3>开放平台对接重要参数说明</h3>
                <div>1.大部分接口请求需要以下公共参数:</div>
                <div class="retract">key:智慧停车开放平台提供的接入账号</div>
                <div class="retract">secret:智慧停车开放平台提供的接入密码</div>
                <div class="retract">parkCode:停车场唯一编码</div>
                <div>2.优惠类接口需要额外的参数:</div>
                <div class="retract">traderCode:商户编号</div>
                <div>3.获取说明</div>
                <div class="retract">申请通过后，会有测试和正式环境参数</div>
            </li>
        </ul>

        <ul>
            <li>
                <h3 class="title">请求类接口</h3>
            </li>
            <li>
                <div>请求类的接口是指合作方主动调用智慧停车开放平台对外暴露的接口,列如查费、缴费</div>
                <br/>
                <h4>一个标准的请求:</h4>
                <h4>业务URL:</h4>
                <pre>{{ url.test }}/openydt/api/v3/{cmd}?sign=xxx</pre>
                <h4>请求包头:</h4>
                <pre>
Accept:application/json;
Content-Type:application/json;charset=utf-8;
Content-Length:256;
Authorization:XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX</pre>
                <h4>业务body:</h4>
                <pre>标准JSON</pre>
                <h4>响应</h4>
                <pre>{{JSON.stringify({"data": {}, "message": "业务成功", "resultCode": 0, "status": 1}, null, 4)}}</pre>
                <div>说明</div>
                <h4>1.{cmd}是业务编码，指此次请求是哪个业务</h4>
                <h4>2.sign是签名信息</h4>
                <div class="retract">• URL后必须带有sign参数，例如：sign=XXXXXXXXXXXXXXXXX</div>
              <div class="retract">
                <p class="red-text">• V3签名方式</p>
                sign=MD5加密(key+冒号+时间+冒号+入参+冒号+密钥)，加密后的值应转换为32位小写字符串，如
                <br>
                入参为：{"parkCode":"123123"} （ 注：该为json格式化后的字符串，不存在空格、换行）
                <pre>MD5("abc:20170416142030:{"parkCode":"123123"}:123456") = f1e1e7f8bc710dd6633bc0d9a9336207</pre>
              </div>
                <div class="retract">• 其中账号和密码分别对应的智慧停车开放平台分配的key和secret</div>
                <div class="retract">• 时间 是当前系统时间，格式"yyyyMMddHHmmss",如：20170416142030</div>
                <div class="retract">• 入参 为请求接口时候的参数body</div>
                <h4>3. Authorization是包头验证信息</h4>
                <div class="retract">• 使用Base64编码（key + 冒号 + 时间戳）,如
                    <pre>Base64("abc:20170416142030") = YWJjOjIwMTcwNDE2MTQyMDMw</pre>
                </div>
                <div class="retract">• 冒号为英文冒号</div>
                <div class="retract"> <p class="red-text">• 时间 是当前系统时间，格式"yyyyMMddHHmmss"，需与sign中时间戳相同。</p></div>
                <h4>4.目前仅支持json格式的请求和响应</h4>
                <h4>5.时间 有效时间为10分钟</h4>
                <h4>6.响应格式说明</h4>
                <div>
                <template>
                    <el-table
                    :data="respTable"
                    style="width: 100%">
                        <el-table-column
                            prop="info1"
                            label="变量名"
                            width="110">
                        </el-table-column>
                        <el-table-column
                            prop="info2"
                            label="是否必填"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            prop="info3"
                            label="字段类型"
                             width="120">
                        </el-table-column>
                         <el-table-column
                            prop="info4"
                            label="字段名"
                            width="100">
                        </el-table-column>
                         <el-table-column
                            prop="info5"
                            label="说明">
                        </el-table-column>
                    </el-table>
                </template>
                </div>
              <h4>7.请求限速说明</h4>
              <div class="retract"> <p class="red-text">• 授权车场数低于60个，则默认限速为 300次/分钟（5次/秒）</p></div>
              <div class="retract"> <p class="red-text">• 授权车场数高于60个，则默认限速为 车场数*5/分钟 例如车场数120则为120*5=600次/分钟（10次/秒）</p></div>
              <h4>8.避免不合理的接口组合</h4>
              <div class="retract"> <p class="red-text">如查费接口和查停车信息接口，由于查费已经包含所需车场信息，则不需要组合使用</p></div>
            <br>
            </li>
        </ul>

        <ul>
            <li>
                <h3 id="4" class="title">上报类接口</h3>
            </li>
            <li>
                <div>上报类接口的接口是指合作方按照智慧停车开放平台的接口规范提供接口给智慧停车主动调用，例如进场上报，离场上报。</div>
                <br/>
                <div>1.URL、请求响应参数格式和加密方式与请求端相同，接收时采用与发送时相同的方式对签名和授权信息进行验密以确保信息的一致性</div>
                <div>2.考虑到安全问题，强烈建议使用HTTPS方式进行接收。</div>
                <div>3.上报失败重发机制:如果智慧停车开发平台收到合作商的响应不是成功或超时，智慧停车开放平台会通过一定的策略定期重新发起推送，尽可能提高推送的成功率，但智慧停车开放平台不保证通知最终能成功。</div>
                <div>4.上报失败限制调用机制:增加网络状态判断（针对具体上报接口），连续请求某个接口一定次数都失败，则这个接口上报则认为对方网络/系统繁忙，后面该授权商该接口每分钟只会调用一次(后面上报的则直接入库，并触发发调用)，一旦调用成功则恢复正常调用，否则继续维持这种状态。</div>
<!--                <div>5.请求重传历史未接收上报数据机制:授权商可调用接口出发历史未成功上报数据重发，增强推送成功率。</div>-->
<!--                <div>6.告警问题排查可参考<el-link type="primary" :href="alarmGuideUrl">告警指南</el-link> </div>-->
                <div>
                  <p class="red-text"> 5.成功的响应如下：（status=1则认为成功，否则智慧停车开放平台认为推送失败），接口推送数据一天内失败率达到85%时，将冻结该接口上报</p>
                </div>
                <pre>{{JSON.stringify({"data": {}, "message": "ok", "resultCode": 0, "status": 1}, null, 4)}}</pre>
            </li>
        </ul>

    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: '',
    props: {
        'Pdatas': {
            type: Object,
        }
    },
    data() {
        return {
            respTable: [
                { info1: 'status', info2: '是', info3: 'int', info4: '状态码',info5:'1业务成功,2业务失败,3系统异常,4签名错误,5key错误,6未授权,7请求参数不完整' },
                { info1: 'resultCode', info2: '是', info3: 'int', info4: '业务码',info5:'只有状态码为2时才生效，状态码不为2时业务结果为0;901-系统发生异常,902-远程服务器未响应,903-运营商不存在,904-停车场不存在,905-未找到在场车辆,906-账单不存在,907-账单已同步,908-其它错误,909-请求参数错误,910-找不到授权商下面的停车场,911-无权限操作该停车场,912-查费已超时，请重新查费,1801-找不到指定车辆'},
                { info1: 'message', info2: '是', info3: 'String', info4: '结果描述' },
                { info1: 'data', info2: '是', info3: 'JSONObject', info4: '返回数据' }
            ],
            othersData: [],
            explainWidth: 200,
            alarmGuideUrl: 'Api/alarmGuide#0',
            customHelp: ''
        }
    },
    computed: {
      ...mapState(["url"])
    },
    created() {
        if (this.$root.customConfig.help && Object.keys(this.$root.customConfig.help).length > 0) {
            this.customHelp = this.$root.customConfig.help;
        }
        this.initCommonUrls()
    },
    watch: {
      '$route'(to, from) {
        this.initCommonUrls()
      }
    },
    methods: {
      initCommonUrls() {
        let url = window.location.href;
        this.alarmGuideUrl = '/Api/alarmGuide#0'
      },
      jump() {
        window.open("/Api/apply");
      }
    },

}
</script>

<style lang="less" scoped>
.content {
    // font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", '黑体', Arial, sans-serif;
    font-size: 14px; // background-image: url(../../assets/img/back.png);
    line-height: 1.6;
    color: #1f2d3d;
    h3 {
        margin: 0;
        padding: 0px 0 20px 0; // font-family: HiraginoSansGB-W3;
        font-size: 18px;
        color: #111B29;
        letter-spacing: 0
    }
    a {
        font-size: 13px;
    }
    ul {
        padding: 5px 10px;
        li {
            text-align: left;
        }
        a.el-link {
            text-decoration: none;
        }
    }
    .retract {
        padding-left: 15px;
    }
    pre {
        background-color: #f6f6f6;
        font-size: 12px;
    }
}

.subName {
    padding: 15px 0 10px 15px;
    max-width: 90%;
    min-width: 80%;
    color: #333;
}

table {
    display: table;
    max-width: 90%;
    min-width: 80%;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: auto;
    border-bottom: 1px solid #e7e7eb;
}

thead tr:first-child {
    background-color: #f6f8f9;
}

table tr:first-child {
    border: none;
}

table tr {
    border-top: 1px solid #e7e7eb;
}

table th {
    font-weight: 400;
    color: #8d8d8d;
    text-align: left;
    height: 40px;
    padding: 6px 12px;
    white-space: nowrap;
    border: none;
}

table td {
    // height: 35px;
    padding: 15px 12px;
    text-align: justify;
}

.red-text {
  color: red; /* 使用 CSS 颜色名 */
}

/* 或者使用十六进制颜色代码 */
.red-text {
  color: #FF0000;
}
</style>



// WEBPACK FOOTER //
// src/components/Doc/guide.vue